import './sentry';                    // Sentry.init(...) runs on import — MUST be first
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Pages from './pages';
import app from './components/app';
import reportWebVitals from './reportWebVitals';

// Root level on purpose: every mode (admin editor, live, pages, templates) goes
// through this bundle, so tagging <body class="reseller-view"> here covers all
// of them and lands before React's first render.
app.isResellerDomain();

// Mount (or re-mount) React into #ai-editor. On subsequent calls we reuse the
// same root and let React reconcile the tree — no createRoot warning, no
// leaked fiber trees, no double-attached event listeners.
//
// If the container node identity changes (e.g., ai-code.js removes and
// recreates #ai-editor), we detect that and cleanly unmount the stale root
// before creating a fresh one on the new node.
let currentRoot = null;
let currentContainer = null;

function loadAiEditor() {
  const el = document.getElementById('ai-editor');
  if (!el) return;

  if (currentContainer && currentContainer !== el) {
    try { currentRoot && currentRoot.unmount(); } catch (_) { /* ignore */ }
    currentRoot = null;
    currentContainer = null;
  }

  if (!currentRoot) {
    currentRoot = ReactDOM.createRoot(el);
    currentContainer = el;
  }

  currentRoot.render(
    <Sentry.ErrorBoundary
      fallback={<div style={{padding:16,color:"#b91c1c"}}>Something went wrong. The issue has been reported.</div>}
    >
      <Pages />
    </Sentry.ErrorBoundary>
  );
}
window.loadAiEditor = loadAiEditor;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
